document.addEventListener("DOMContentLoaded", initSansuSwiper);

document.addEventListener("shopify:section:load", initSansuSwiper);

document.addEventListener("shopify:section:reorder", initSansuSwiper);

document.addEventListener("shopify:block:select", initSansuSwiper);

function initSansuSwiper() {

  document.querySelectorAll(".sansu-swiper").forEach((slider) => {

    if (slider.swiper) {
  slider.swiper.destroy(true, true);
}

    const autoplayEnabled =
      slider.dataset.autoplay === "true";

    const speed =
      parseInt(slider.dataset.speed || 5) * 1000;

    const pauseOnHover =
      slider.dataset.pauseOnHover === "true";

    const swiper = new Swiper(slider, {

      loop: true,

      speed: 700,

      grabCursor: true,

      watchOverflow: true,

      preloadImages: false,

      observer: true,

observeParents: true,

resizeObserver: true,

      keyboard: {
        enabled: true
      },

      autoplay: autoplayEnabled
        ? {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          }
        : false,

    
      navigation: false,
      pagination: false,

    });

    if (pauseOnHover && autoplayEnabled) {

      slider.addEventListener("mouseenter", () => {
  if (swiper.autoplay) {
    swiper.autoplay.pause();
  }
});

slider.addEventListener("mouseleave", () => {
  if (swiper.autoplay) {
    swiper.autoplay.resume();
  }
});

    }

    slider.querySelectorAll(".swiper-slide").forEach((slide) => {

      const link = slide.dataset.bannerLink;

      if (!link) return;

      slide.style.cursor = "pointer";

      if (slide.dataset.clickBound === "true") return;

      slide.dataset.clickBound = "true";

      slide.addEventListener("click", function (e) {

        if (
  e.target.closest("a, button, input, textarea, select")
) {
  return;
}

        const newTab =
          slide.dataset.bannerNewTab === "true";

        if (newTab) {
          window.open(link, "_blank");
        } else {
          window.location.href = link;
        }

      });

    });

  });

}